import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Shield, Loader2, Lock, Eye, EyeOff } from 'lucide-react';
import { adminLogin } from '../lib/api';
import { toast } from 'sonner';

const SecureAdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      toast.error('Ingresa email y contraseña');
      return;
    }

    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      if (res.data.token) {
        localStorage.setItem('admin_token', res.data.token);
        toast.success('Acceso concedido');
        navigate('/admin');
      }
    } catch (err) {
      console.error('Admin login error:', err);
      toast.error(err.response?.data?.detail || 'Credenciales incorrectas');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#090A0D] flex items-center justify-center px-4">
      <Card className="w-full max-w-sm bg-[#0E1016] border border-white/[0.08]">
        <CardHeader className="text-center pb-2">
          <div className="w-14 h-14 rounded-2xl bg-[rgba(255,198,64,0.1)] border border-[rgba(255,198,64,0.25)] flex items-center justify-center mx-auto mb-4">
            <Shield size={28} className="text-[#FFC640]" />
          </div>
          <CardTitle className="text-lg font-heading text-[#F7F2E7]">Acceso Restringido</CardTitle>
          <p className="text-xs text-[#F7F2E7]/40 mt-1">Panel de Administración</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-[#121521] border-white/[0.12] text-[#F7F2E7] focus:border-[#FFC640] h-10"
                placeholder="Correo electrónico"
                autoComplete="email"
              />
            </div>
            <div className="space-y-1 relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#121521] border-white/[0.12] text-[#F7F2E7] focus:border-[#FFC640] h-10 pr-10"
                placeholder="Contraseña"
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F7F2E7]/40 hover:text-[#F7F2E7]/70"
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-10 bg-[#FFC640] text-[#090A0D] font-heading font-semibold hover:bg-[#FFD36B] rounded-xl"
            >
              {loading ? <Loader2 size={18} className="animate-spin" /> : (
                <>
                  <Lock size={16} className="mr-2" />
                  Acceder
                </>
              )}
            </Button>
          </form>
          <p className="text-[9px] text-[#F7F2E7]/20 text-center mt-4">
            Solo personal autorizado
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default SecureAdminLogin;
